let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("phCSH")).then(() => parcelRequire('2wBQ6'));